<ng-container *ngIf="permConfig.isViewAllowed">
  <div class="container-fluid">
    <app-page-title title="List Invoice"></app-page-title>
    <div class="row col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-2">
                <div class="col-12 d-flex justify-content-end">
                  <button type="button" class="btn btn-primary btn-sm me-2" (click)="printPdfAction(null, 'multiple')" [disabled]="!areSelected">
                    <i class="mdi mdi-printer me-1"></i>Print
                  </button>
                  <div ngbDropdown class="d-inline-block dropdown">
                    <button type="button" class="btn btn-success btn-sm" ngbDropdownToggle>
                      Select Action<i class="mdi mdi-chevron-down d-none d-xl-inline-block ms-1"></i>
                    </button>
                    <div ngbDropdownMenu>
                      <a class="dropdown-item" routerLink="add"><i class="mdi mdi-plus font-size-16 align-middle me-2"></i>Generate Invoice</a>
                      <span class="dropdown-item" [ngClass]="{'disabled-link': !areSelected, 'enabled-link': areSelected}"(click)="generateIRN()">
                        <i class="mdi mdi-lightning-bolt-outline font-size-16 align-middle me-2"></i>Generate IRN</span>
                      <span class="dropdown-item" [ngClass]="{'disabled-link': !areSelected, 'enabled-link': areSelected}"(click)="sendInvoice($event)">
                        <i class="fas fa-envelope font-size-12 align-middle ms-1 me-2"></i>Send e-Invoice</span>
                    </div>
                  </div>
                </div>
            </div>
              <div class="col-md-12 grid-container">
                <ag-grid-angular #agGrid style="width: 100%; height: 100%" id="myGrid" class="ag-theme-balham"
                  [rowData]="rowData" [columnDefs]="columnDefs" [animateRows]="true" [context]="context"
                  [defaultColDef]="defaultColDef" [suppressMenuHide]="true" [pagination]="true" [enableCellTextSelection]="true"
                  (gridReady)="onGridReady($event)" [gridOptions]="gridOptions" (rowSelected)="onRowSelected()">
                </ag-grid-angular>
              </div>
          </div>
        </div>
    </div>
  </div>


  <div *ngIf="isInvoicePrintModalOpen" class="modal">
    <div class="modal-content">
      <span class="right-bar-toggle float-end" class="close" (click)="hide()">&times;</span>
      <div class="modal-header">
        <h4 class="modal-title">Invoice Message</h4>
      </div>

      <div class="h2-pad">
        <form [formGroup]="modalForm">          
          <div >
            <div class="mb-2 d-flex flex-column">
              <div class="label">
                <label for="status" class="form-label">Output Format</label><br>
                <span style="font-style: italic;font-size: 10px;">This will provide the output in the selected format.</span>
              </div>             
              <div class="col-md-3">
              <div role="group" aria-label="radio button group" class="btn-group">
                <input #btnradio4 type="radio" id="btnradio4" autocomplete="off" class="btn-check"
                  formControlName="outPutType" value="pdf">
                <label for="btnradio4" class="btn btn-outline-secondary btn-sm">Pdf</label>

                <input #btnradio5 type="radio" id="btnradio5" autocomplete="off" class="btn-check"
                  formControlName="outPutType" value="excel">
                <label for="btnradio5" class="btn btn-outline-secondary btn-sm">Excel</label>
              </div>
            </div>
            </div>            
          </div>

          <div class="col-md-12">
            <div class="mb-2">
                <label for="invoiceformat" class="form-label">Invoice Template</label>
                <ng-select id="invoicetemplate" placeholder="Select" [items]="invoiceTemplateList"
                    bindLabel="templatename" [bindValue]="'id'" 
                    formControlName="ddlinvoiceTemplate">
                </ng-select>
            </div>
          </div>

  
          <textarea type="text" class="form-control form-control-sm" id="txtInvoiceMessage" placeholder="Enter Invoice Message (optional)" formControlName="txtInvoiceMessage"></textarea>
  
          
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-dark" (click)="printData()">Print</button>
      </div>
    </div>

  </div>



</ng-container>
<ng-container *ngIf="!permConfig.isViewAllowed">
  <app-forbidden></app-forbidden>
</ng-container>
